import { Link } from 'react-router-dom';
import logo from './assets/logo.png';
import uspsImage from './assets/usps.png';
import musecoImage from './assets/museco.jpg';
import trainerImage from './assets/trainer.png';
import './App.css';

function App() {
  const projects = [
    {
      id: 1,
      name: "USPS Media Mailer",
      url: "https://apps.shopify.com/usps-media-mailer",
      description:
        "Shopify app with the ability to assign USPS Media Mail as eligible in cart checkout.",
      image: uspsImage,
    },
    {
      id: 2,
      name: "Museco.io",
      url: "",
      description:
        "SAAS platform Museco.io will centralize data and automation for touring and live performances.",
      image: musecoImage,
    },
    {
      id: 3,
      name: "Cycling Trainer",
      url: "",
      description:
        "A alternate option for the Pelaton subscription service for cycling trainers.",
      image: trainerImage,
    },
  ];

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
       
       
      </header>
      
      <h1 style={{ textAlign: 'center', paddingTop: '2rem' }}>Apollo Audio and Data</h1>
      <main className="projects-container">
        {projects.map(project => (
          <div key={project.id} className="project-card">
            <img src={project.image} className="project-logo" alt={`${project.name} logo`} />
            <h2>{project.name}</h2>
            <p className="project-description">{project.description}</p>
            {project.url ? (
              <a 
                href={project.url}
                className="project-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit Project →
              </a>
            ) : (
              <span className="coming-soon">
                Coming Soon
              </span>
            )}
          </div>
        ))}
      </main>
      <footer style={{ textAlign: 'center', padding: '40px 20px', color: '#666' }}>
        <Link to="/privacy-policy" style={{ color: '#404C85', textDecoration: 'none' }}>
          Privacy Policy
        </Link>
      </footer>
    </div>
  );
}

export default App;
